import { StoreModule } from '@ngrx/store';
import { reducers } from '../reducers';

export const Store = StoreModule.forFeature('returns', reducers);
